import _ from 'lodash'

import CONSTANTS from 'core/data-model/constants/values'

import { isNil, isNotNil } from 'core/service/lib/type-check'
import { createSelector } from 'reselect'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'

import {
  getSumAssured$,
  getSelectedRiders,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
} from 'quick-quote/product-common/coverage-plan/selectors'

export const canProceedPerfectLifeBenefitIllustration = createSelector(
  getSumAssured$,
  getBasicPremium$,
  getTotalPremium$,
  getBasicPlanErrorMessage,
  getSelectedRiders,
  canProceedToCoveragePlan,
  getSelectedDisplayProduct,
  (
    sumAssured$,
    basicPremium,
    totalPremium$,
    basicPlanErrorMessage,
    selectedRiders,
    canProceedToCoveragePlan,
    selectedDisplayProduct
  ) => {
    const selectedRiderInvalidMessages = selectedRiders.filter((rider) =>
      isNotNil(rider.errors.find((error) => error.type === CONSTANTS.VALIDATION))
    )

    const canProceed =
      canProceedToCoveragePlan &&
      sumAssured$.isOk &&
      basicPremium.isOk &&
      totalPremium$.isOk &&
      _.isEmpty(selectedRiderInvalidMessages) &&
      _.isEmpty(basicPlanErrorMessage)
    if (selectedDisplayProduct.type === CONSTANTS.CAMPAIGN_PRODUCT_TYPE) {
      const selectedRiderCodes = selectedRiders.map((rider) => rider.code)
      return (
        canProceed &&
        selectedDisplayProduct.requiredRiders != null &&
        selectedDisplayProduct.requiredRiders.every((riderCode) => {
          return selectedRiderCodes.indexOf(riderCode) > -1
        })
      )
    }
    return canProceed
  }
)

export const getPerfectLifePlans = (state) => _.get(state, 'selectedDisplayProduct.plans', [])

export const getSelectCampaignPlan = (state) => _.get(state, 'selectedDisplayProduct.selectedCampaignPlan', '')

export const getPerfectLifeOptionsPlans = createSelector(getPerfectLifePlans, (plans) => {
  return plans.map((v) => ({
    text: v.name,
    value: v.planCode,
  }))
})
